import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'

const ZODIAC_SIGNS = [
    { slug: 'aries', label: 'Aries', image: Common_Images_Transport?.Aries },
    { slug: 'taurus', label: 'Taurus', image: Common_Images_Transport?.Taurus },
    { slug: 'gemini', label: 'Gemini', image: Common_Images_Transport?.Gemini },
    { slug: 'cancer', label: 'Cancer', image: Common_Images_Transport?.Cancer },
    { slug: 'leo', label: 'Leo', image: Common_Images_Transport?.leo },
    { slug: 'virgo', label: 'Virgo', image: Common_Images_Transport?.Virgo },
    { slug: 'libra', label: 'Libra', image: Common_Images_Transport?.Libra },
    { slug: 'scorpio', label: 'Scorpio', image: Common_Images_Transport?.Scorpio },
    { slug: 'sagitarius', label: 'Sagitarius', image: Common_Images_Transport?.Sagitarius },
    { slug: 'capricorn', label: 'Capricorn', image: Common_Images_Transport?.Capricorn },
    { slug: 'aquarius', label: 'Aquarius', image: Common_Images_Transport?.Aquarius },
    { slug: 'pisces', label: 'Pisces', image: Common_Images_Transport?.Piscis },
]

const Horoscope = ({ horoscopeType = 'today' }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {ZODIAC_SIGNS.map(({ slug, label, image }) => (
                <div key={slug} className="gi-product-content">
                    <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                        <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                            <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                                <Link
                                    to={`/horoscope-details/${horoscopeType}/${slug}`}
                                    className="image productimg7 relative block overflow-hidden"
                                >
                                    <img
                                        className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                        src={image}
                                        alt={label}
                                    />
                                </Link>
                            </div>
                        </div>
                        <div className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">
                            <Link to={`/horoscope-details/${horoscopeType}/${slug}`}>
                                <h5 className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                    {label}
                                </h5>
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default Horoscope